import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ExternalLink } from "lucide-react";
import { displayTitleForTopic } from "@/lib/factAlignment";

export const RelatedDossiers = ({ currentSlug }) => {
        const [related, setRelated] = useState([]);

        useEffect(() => {
                if (!currentSlug) return;
                api.get(`/topics/${currentSlug}/related`)
                        .then((res) => {
                                setRelated(res.data || []);
                        })
                        .catch((err) => console.error("Error fetching related topics:", err));
        }, [currentSlug]);

        if (related.length === 0) return null;

        return (
                <section className="relative mt-24 mb-16 pt-16 border-t border-[var(--line-strong)]">
                        {/* Conspiracy Web Aesthetic Lines */}
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[2px] h-16 bg-[var(--controversy)] opacity-50" />
                        <div className="absolute top-8 left-1/4 w-1/2 h-[2px] border-t-2 border-dashed border-[var(--controversy)] opacity-40" />

                        <div className="max-w-[1200px] mx-auto px-6 relative z-10">
                                <h3 className="text-3xl font-serif text-[var(--ink)] mb-12 flex items-center gap-3">
                                        <span className="w-4 h-4 bg-[var(--controversy)] inline-block"></span>
                                        Teia de Dossiês (Relacionados)
                                </h3>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                                        {related.map((topic) => {
                                                const displayTitle = displayTitleForTopic(topic);
                                                return (
                                                        <Link
                                                                key={topic.id}
                                                                to={`/topico/${topic.slug}`}
                                                                className="group relative bg-[var(--paper)] p-6 border border-[var(--line)] hover:border-[var(--controversy)] transition-colors shadow-sm hover:shadow-[4px_4px_0_var(--controversy)]"
                                                        >
                                                        {/* Red string pin */}
                                                        <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-[var(--controversy)] shadow-md border-2 border-white z-20" />
                                                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[2px] h-4 bg-[var(--controversy)] opacity-50 -z-10" />

                                                        <span className="stamp text-xs mb-4 inline-block opacity-70 group-hover:opacity-100 group-hover:text-[var(--controversy)]">
                                                                Dossiê #{(topic.id || "").slice(0, 8)}
                                                        </span>
                                                        <h4 className="font-serif text-xl font-bold leading-tight mb-3 text-[var(--ink)] group-hover:underline decoration-[var(--controversy)] decoration-2 underline-offset-4">
                                                                {displayTitle}
                                                        </h4>
                                                        <p className="text-[var(--ink-soft)] text-sm line-clamp-3 font-serif">
                                                                {topic.summary}
                                                        </p>
                                                        
                                                        <div className="mt-6 flex items-center justify-between text-xs font-mono text-[var(--ink-faint)]">
                                                                <span className="uppercase">{topic.category}</span>
                                                                <span className="flex items-center gap-1 group-hover:text-[var(--controversy)] transition-colors">
                                                                        Investigar <ExternalLink size={12} />
                                                                </span>
                                                        </div>
                                                        </Link>
                                                );
                                        })}
                                </div>
                        </div>
                </section>
        );
};
